module.exports = __webpack_public_path__ + "static/img/图层24.649029e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层24.png
// module id = ZDGG
// module chunks = 0